import React from "react";
import { Auth, Hub, API, graphqlOperation } from "aws-amplify";
import {getUser } from './graphql/queries'
import {registerUser} from './graphql/mutations'
import { Authenticator } from "aws-amplify-react";
import { Router, Route , Switch } from "react-router-dom";
import createBrowserHistory from 'history/createBrowserHistory'
import {AmplifyTheme} from "aws-amplify-react";
//import '@aws-amplify/ui/dist/style.css';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import MarketPage from './pages/MarketPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import GMarkPage from './pages/gmarkpage'
import Home from './components/Home/Home'
import HPayList from './components/HPayList';
import HCart from './components/HCart';
import CartContextProvider from './components/contexts/CartContext';
import WishlistContextProvider from './components/contexts/WishlistContext';
import Footer from './components/Footer';
import Services from './components/Services'
import StandardImageList from './components/StandardImageList'
import PrivateRoute from './components/auth/PrivateRoute';
import GMarketAltList from './components/GMarketAltList';
import BottomNav from './components/BottomNav';
import ScrollToTop from "react-scroll-to-top";
import Box from '@mui/material/Box';
import ProductPage from './pages/ProductPage';
import ScrollToTopOnNavigation from './components/ScrollToTopOnNavigation';

import Club from './components/Club'
import "./App.css";

export const history = createBrowserHistory()
export const UserContext = React.createContext()
export const CartContext = React.createContext()





class App extends React.Component {
  state = {
    user: null,
    userAttributes: null,
    admin:0,
    userlogin: false
  };
  



  componentDidMount() {
    this.getUserData();
    Hub.listen('auth', this, 'onHubCapsule')
  }

fetchUserAttributes = async authUserData => {
    const attributesArr = await Auth.userAttributes(authUserData)
    const attributesObj = Auth.attributesToObject(attributesArr)
    return attributesObj
  }

  getUserData = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const userAttributes = await this.fetchUserAttributes(user);
      this.setState({ user, userAttributes });
      this.checkadminUser(user);
    } catch (err) {
      console.log("User not logged in, fetching anonymous credentials", err);
      try {
        const credentials = await Auth.currentCredentials();
        this.setState({ user: credentials, userAttributes: null });
      } catch (credErr) {
        console.error("Error fetching anonymous credentials", credErr);
      }
    }
  }

  onHubCapsule = capsule => {
    switch (capsule.payload.event) {
      case "signIn":
        console.log("signedIn");
        this.getUserData();
        this.registerNewUser(capsule.payload.data);
        break;
      case "signUp":
        console.log("signed up");
        break;
      case "signOut":
        console.log("signed out");      
        break;
      default:
        return;
    }
  }

  checkadminUser = async (user) => {
    const getUserInput = {
      id: user.attributes.sub
    };

    const { data } = await API.graphql(graphqlOperation(getUser, getUserInput));

    if (data.getUser) {
      
      console.log("the data is ", { data });
      this.setState({ admin:data.getUser.admin})
    }

  }



  registerNewUser = async (signInData) => {
    const getUserInput = {
      id: signInData.signInUserSession.idToken.payload.sub
    };

    const { data } = await API.graphql(graphqlOperation(getUser, getUserInput));


    if (!data.getUser) {
      try {
        const registerUserInput = {
          ...getUserInput,
          username: signInData.username,
          email: signInData.signInUserSession.idToken.payload.email,
          registered: true,
          admin:0
        };

        const newUser = await API.graphql(
          graphqlOperation(registerUser, { input: registerUserInput })
        );
        console.log({ newUser });
      } catch (error) {
        console.error('Error registering new user', error);
      }
    } else {
     
      this.setState({ admin:data.getUser.admin})
      console.log("setting up the admin here is " ,{data})
    }
  };




  handleSignout = async () => {
    try {
      await Auth.signOut({ global: true })
      this.setState({ user: null, userlogin: false });
    } catch (err) {
      console.error('Error signing out user', err);
    }
  }

  handleSignin = async () => {
    try {
      this.setState({ user: null,userlogin: true });
    } catch (err) {
      console.error('Error signing in user', err);
    }
  }

  render() {

    const { user, userlogin, userAttributes,admin  } = this.state;
    const isLogged = !!(user && user.username);
    let uservalid = false;
    let isadmin = false;
    
    if (!isLogged) {
       uservalid = false; 
    } else { 
       if (admin){ 
           isadmin = true; 
       } else {
            isadmin = false;
       }
      uservalid = true;   
    }


    return (!isLogged && userlogin) ? (
      <Box
        sx={{
          width: '100%',
          maxWidth: 480,
          mx: 'auto',
          px: 2,
          my: 4
        }}
      >
        <Authenticator theme={theme} />
      </Box>) : !isLogged ? (

        <CartContextProvider>
          <WishlistContextProvider>
            <UserContext.Provider value={{ user: null }}>
              <ScrollToTop smooth color="#6f00ff" />
              <Router history={history}>
                <>
                  <ScrollToTopOnNavigation />
                  <Club
                    user={user}
                    handleSignin={this.handleSignin}
                    handleSignout={this.handleSignout}
                  />

                  <div className="app-container">
                    <Switch>
                <Route exact path="/" component={GMarketAltList} />
                <Route exact path="/about" component={Services} />
                <Route exact path="/discover" component={StandardImageList} />
                <Route name="profile-page" path="/profile" 
                    component={({ match }) => (
                      <Authenticator theme={theme} />

                    )}
                 />
                 
                <Route path="/cart" component={HCart} />
                <Route path="/HPayList" 
                    component={({ match }) => (
                      <Authenticator theme={theme} />
                    )}
                 />
                 
                <Route exact path="/markets/:marketId"
                  component ={({ match }) => (
              
                     <GMarkPage  user={user} marketId={match.params.marketId} />
                  )}
                />
                <Route exact path="/products/:productId" component={ProductPage} />
                    </Switch>
                  </div>
                  <Home />
                  <Footer />
                  <BottomNav />
                </>
              </Router>
            </UserContext.Provider>
          </WishlistContextProvider>
        </CartContextProvider>
      
      ) 

      : (
        <CartContextProvider>
          <WishlistContextProvider>
            <ScrollToTop smooth color="#6f00ff" />
            <UserContext.Provider value={{ user }}>

            <Router history={history}>
              <>
                <ScrollToTopOnNavigation />
                <Club user={user} handleSignin={this.handleSignin}
                  handleSignout={this.handleSignout} />
           
                          
                <div className="app-container">
       
                  <PrivateRoute uservalid={uservalid}  path="/"
                    isadmin={isadmin }
                    exact component={HomePage}
                  />
                  <Route exact path="/about" component={Services} />
                  <Route exact path="/discover" component={StandardImageList} />
                  <PrivateRoute uservalid={uservalid} path="/profile"
                    user={user}
                    userAttributes={userAttributes}
                    exact component={ProfilePage}
                  />
                  <PrivateRoute 
                    uservalid={uservalid} 
                    path="/orders"
                    exact component={OrderHistoryPage}
                  />

                  <Route path="/cart" component={HCart} />
                  <PrivateRoute uservalid={uservalid} path="/HPayList" exact component={HPayList} />
                  <Route exact path="/products/:productId" component={ProductPage} />
                    <Route exact path="/markets/:marketId"
                      component={({ match }) => (
                        isadmin ? (<MarketPage user={user} marketId={match.params.marketId} />) : (
                          <GMarkPage user={user} marketId={match.params.marketId} />)
                         
                      )}
                  />

                </div>
                <Home/>
                <Footer />
                <BottomNav />
              </>
            </Router>
          </UserContext.Provider>
          </WishlistContextProvider>
        </CartContextProvider>

        );
      
     
  }
}

const theme = { 
  ...AmplifyTheme,
  navBar: {
    ...AmplifyTheme.navBar,
    backgroundColor: '#ffc0cb'
  },

  button: {
    ...AmplifyTheme.button,
    backgroundColor: '#ffc0cb'
},
Container: {
  ...AmplifyTheme.Container,
  display: 'flex',
  textAlign: 'center'
},
formContainer: {
  ...AmplifyTheme.Container,
  display: 'flex',
  textAlign: 'center'
}

};


export default App;
